export const validatorsFiltersSalesChallengeOrder = {
  year: 'year',
  regionId: 'regionId',
  lineId: 'lineId',
  subRegionId: 'subRegionId',
  territoryId: 'territoryId',
  zoneId: 'zoneId',
  clientId: 'clientId',
};
